export default {
    unexpected_error: "A aparut o eroare neasteptata",
}
